import React from 'react';
import { Button, Segment } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';

const TableHeader = (props) => {
  const { t, onAdd } = props;
  
  return (
    <Segment basic>
      <Button
        icon='wrench'
        content={t('my:workshops.addButton')}
        onClick={onAdd}
      />
    </Segment>
  );
};

export default withNamespaces('my')(TableHeader);



// WEBPACK FOOTER //
// ./src/private/user/components/Workshops/Header.js